import { Text, View } from '@react-pdf/renderer'
import moment from 'moment'
import { IInvoiceFr } from '../../../types/invoice-fr'
import { styles } from '../styles'
import { useTranslation } from 'react-i18next'

const DiagnosticInfo = ({ invoiceData }: { invoiceData: IInvoiceFr }) => {
  const { t } = useTranslation()

  return (
    <View style={styles.sectionContainer}>
      <Text style={styles.sectionHeader}>
        {t('sharedDiagnostic.invoice.titleInfo')}
      </Text>
      <View style={styles.divider} />
      <View style={styles.cardContainer}>
        <View style={styles.flexRowContainer}>
          <Text style={styles.labelText}>
            {t('sharedDiagnostic.invoice.requestReference')}
          </Text>
          <Text style={styles.valueText}>{invoiceData.diagnosticId}</Text>
        </View>
        <View style={styles.flexRowContainer}>
          <Text style={styles.labelText}>
            {t('sharedDiagnostic.invoice.createdAt')}
          </Text>
          <Text style={styles.valueText}>
            {moment(invoiceData.diagnosticCreatedAt).format('DD/MM/YYYY HH:mm')}
          </Text>
        </View>
      </View>
    </View>
  )
}

export default DiagnosticInfo
